import { makeStyles, Theme, useTheme } from '@material-ui/core';
import homeIcon from '../../assets/icons/home.svg';
import officeIcon from '../../assets/icons/office.svg';
import elsewhereIcon from '../../assets/icons/elsewhere.svg';
import courtIcon from '../../assets/icons/court.svg';
import organization from 'utils/organization';

import { UserDto } from 'utils/wemble-api.generated';

const useStyles = (small?: boolean) => makeStyles((theme) => ({
  profile: {
    position: 'relative',
    height: small ? 90 : 100,
    width: small ? 90 : 100,
    borderRadius: '50%',
    border: 'solid 5px white',
    [theme.breakpoints.down('xs')]: {
      width: small ? 60 : 65,
      height: small ? 60 : 65,
      border: 'solid 3px white',
    }
  },
  profile__img: {
    width: '100%',
    overflow: 'hidden',
    borderRadius: '50%',
  },
  profile__initials: {
    backgroundColor: '#efefef',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    borderRadius: '50%',
    fontSize: small ? 24 : 26,
    fontWeight: 600,
  },
  profile__status: {
    position: 'absolute',
    right: -6,
    bottom: -6,
    backgroundColor: 'white',
    width: small ? 28 : 30,
    height: small ? 28 : 30,
    borderRadius: '50%',
    border: 'solid 3px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      filter: 'brightness(0)',
    },
  },
}));

function getInitials(name) {
  const nameSplit = name.toUpperCase().split(' ');
  const nameLength = nameSplit.length;
  if (nameLength > 1) {
    return [nameSplit[0].substring(0, 1), nameSplit[nameLength - 1].substring(0, 1)];
  } else if (nameLength === 1) {
    return [nameSplit[0].substring(0, 1), ''];
  } else return '';
}

function statusColor(status: number | null, theme: Theme) {
  switch (status) {
    case 0:
      return theme.palette.blue.b2;
    case 1:
      return theme.palette.green.g4;
    case 2:
      return theme.palette.yellow.y2;
    case 3:
      return theme.palette.red.r3;
    default:
      return '#666';
  }
}

const Profile = ({ data, onLeave, small }: { data: UserDto; onLeave: boolean, small?: boolean }) => {
  const classes = useStyles(small)();
  const theme = useTheme();

  const companyId = typeof data.company === 'string' ? data.company : data.company?._id ?? '';
  const enableElsewhere = Boolean(organization(companyId).elseWhereOption);
  const enableInCourt = companyId === "65f779d34b718376e412163f";

  return (
    <div className={classes.profile}>
      {data.profilePicture ? (
        <img
          src={'https://d378wr66tg5qg7.cloudfront.net/' + data?.profilePicture}
          alt={data.name + '-image'}
          className={classes.profile__img}
        />
      ) : (
        <div className={classes.profile__initials}>
          <span style={{ color: statusColor(null, theme) }}>{getInitials(data.name)[0]}</span>
          <span style={{ color: statusColor(null, theme) }}>{getInitials(data.name)[1]}</span>
        </div>
      )}
      {!onLeave && (data.atHome !== null || data.onLeave !== null) && !Boolean(organization(companyId).disableWFH) && (
        <div className={classes.profile__status} style={{ borderColor: 'white' }}>
          <img
            src={data.atHome ? homeIcon : ((data.workplaceForecast || [0])[0] == 3 ?
              (enableElsewhere ? (enableInCourt ? courtIcon : elsewhereIcon) : officeIcon)
              : officeIcon)}
            height={small ? 14 : 18}
            alt={data.atHome ? 'home-icon' : 'office-icon'}
          />
        </div>
      )}
    </div>
  );
};

export default Profile;
